export const PRINT_TEMPLATES = [
  {
    id: "classic",
    name: "Classic Professional",
    description: "Traditional business document",
    preview: "linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)",
    colors: {
      primary: "#2563eb",
      primaryForeground: "#ffffff",
      accent: "#dbeafe",
      headerBg: "#2563eb",
      headerText: "#ffffff",
      sectionBg: "#f8fafc",
      borderColor: "#2563eb",
      labelColor: "#4b5563",
      valueColor: "#111827",
      tableTextColor: "#1f2937",
      tableBorderColor: "#9ca3af",
    },
  },
  {
    id: "modern-blue",
    name: "Modern Blue",
    description: "Contemporary gradient style",
    preview: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    colors: {
      primary: "#3b82f6",
      primaryForeground: "#ffffff",
      accent: "#bfdbfe",
      headerBg: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
      headerText: "#ffffff",
      sectionBg: "#f8fafc",
      borderColor: "#3b82f6",
      labelColor: "#374151",
      valueColor: "#111827",
      tableTextColor: "#1f2937",
      tableBorderColor: "#94a3b8",
    },
  },
  {
    id: "ocean-teal",
    name: "Ocean Teal",
    description: "Maritime-inspired design",
    preview: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
    colors: {
      primary: "#14b8a6",
      primaryForeground: "#ffffff",
      accent: "#99f6e4",
      headerBg: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
      headerText: "#ffffff",
      sectionBg: "#f8fafc",
      borderColor: "#14b8a6",
      labelColor: "#115e59",
      valueColor: "#134e4a",
      tableTextColor: "#1f2937",
      tableBorderColor: "#5eead4",
    },
  },
  {
    id: "colorful-gradient",
    name: "Colorful Gradient",
    description: "Vibrant purple-pink style",
    preview: "linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)",
    colors: {
      primary: "#8b5cf6",
      primaryForeground: "#ffffff",
      accent: "#f5d0fe",
      headerBg: "linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)",
      headerText: "#ffffff",
      sectionBg: "#fefcff",
      borderColor: "#8b5cf6",
      labelColor: "#581c87",
      valueColor: "#1f2937",
      tableTextColor: "#1f2937",
      tableBorderColor: "#c084fc",
    },
  },
  {
    id: "sunset-orange",
    name: "Sunset Orange",
    description: "Warm, energetic design",
    preview: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    colors: {
      primary: "#f97316",
      primaryForeground: "#ffffff",
      accent: "#fed7aa",
      headerBg: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
      headerText: "#ffffff",
      sectionBg: "#fffbf7",
      borderColor: "#f97316",
      labelColor: "#7c2d12",
      valueColor: "#1f2937",
      tableTextColor: "#1f2937",
      tableBorderColor: "#fb923c",
    },
  },
  {
    id: "forest-green",
    name: "Forest Green",
    description: "Professional, trustworthy",
    preview: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
    colors: {
      primary: "#22c55e",
      primaryForeground: "#ffffff",
      accent: "#bbf7d0",
      headerBg: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
      headerText: "#ffffff",
      sectionBg: "#f8fdf9",
      borderColor: "#22c55e",
      labelColor: "#166534",
      valueColor: "#14532d",
      tableTextColor: "#1f2937",
      tableBorderColor: "#4ade80",
    },
  },
];

export const PRINT_TEMPLATE_KEY = "shipez-booking-print-template";

export function getTemplateConfig(templateId) {
  return PRINT_TEMPLATES.find((t) => t.id === templateId) || PRINT_TEMPLATES[0];
}

